export default __webpack_public_path__ + "media/images/react_icons/brush-line-23df240458e277095de9a08e37f8bbf2.svg";